import _Vue from 'vue';
import GlobalDialog from '~/components/Dialogs/GlobalDialog.vue';
import { displayDialog } from './state';
import { DialogOptions } from './types';

export function DialogPlugin(Vue: typeof _Vue) {
  Vue.component('global-dialog', GlobalDialog);

  // eslint-disable-next-line no-param-reassign
  Vue.prototype.$dialog = (options: DialogOptions) => displayDialog(options);
}

export default DialogPlugin;
